module.exports = __webpack_public_path__ + "static/media/horse.9f008d19.mp3";